import {
	onFieldInput,
	doFormValidation,
	doPhoneFieldValidation
} from '../lib/forms';

let form;

const init = () => {
	let formModal = document.querySelector('#product-modal');
	let shopList = document.querySelector('.js-shop-list');

	if (!formModal || !shopList) return;

	let fieldsRequired = ['NAME'];

	$(shopList).on('click', '[data-open-modal]', function () {
		const data = $(this).data('open-modal');
		const modal = $('#product-modal');

		modal.find('[name=PRODUCT_ID]').val(data.ID);
		modal.find('[name=PRODUCT_NAME]').val(data.NAME);
		modal.find('[data-product-modal-title]').html(data.NAME);

		modal.removeClass('modal--success-submit');

		if (!form) {
			form = formModal.querySelector('form');

			fieldsRequired.forEach((fieldCode) => {
				let fieldElement = form.querySelector('[name="'+fieldCode+'"]');
				if (!fieldElement) return;

				fieldElement.addEventListener('input', onFieldInput);
			});
		}

		/* Обьект модалок генерируется в основном скрипте */
		window.modalWindow.open('#product-modal');
		return false;
	});

	/* отправка формы */
	$(formModal).on('submit', '[data-form-feedback-product]', function (e) {
		const $form = this;
		const formData = new FormData(this);

		let fieldsChecked = doFormValidation(form, fieldsRequired, e);
		let phoneChecked = doPhoneFieldValidation(form, 'PHONE', e);

		if (!fieldsChecked || !phoneChecked) {
			return false;
		}

		formData.append('URL', location.href);
		BX.ajax.runComponentAction('sp:feedback',
			'send', {
				mode: 'class',
				signedParameters: defaultFeedbackParamsProduct.signedParameters,
				data: formData,
			})
			.then(function (response) {
				if (response.data.status == 'S') {
					$($form).parents('.modal').addClass('modal--success-submit');
					$('[data-product-modal-result]').html('Спасибо за заказ!');
				} else {
					$($form).parents('.modal').addClass('modal--success-submit');
					$('[data-product-modal-result]').html('Произошла ошибка, попробуйте еще раз');
				}
			}, function (response) {
				$($form).parents('.modal').addClass('modal--success-submit');
				$('[data-product-modal-result]').html('Произошла ошибка, попробуйте еще раз');
			});
		return false;
	});
};

export default {
	init
};